export default {
      id: "ic_close_accordionGray-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_close_accordionGray-usage",
      toString: function () {
        return this.url;
      }
    }